// General
import { useEffect } from "react";
// Services
import { useInitCardpayPaymentMutation } from "../../../services/data.service";
// Static Data
import routeConst from "../../../const/routeConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updatePaymentProcessDialog } from "../../../redux/store/dialogStore";
import { updateErrorToast } from "../../../redux/store/toastStore";

const useCardpayCoinsQuickPayment = () => {
  // API variables
  const [
    initCardpayPayment,
    {
      data: initCardpayPaymentData,
      error: initCardpayPaymentErrorData,
      isLoading: initCardpayPaymentLoading,
      isSuccess: initCardpayPaymentSuccess,
      isError: initCardpayPaymentError,
    },
  ] = useInitCardpayPaymentMutation();

  // Redux variables
  const selectedCoinPackage = useSelector(
    (state) => state.products.selectedCoinPackage
  );
  const cardpayCardDetail = useSelector(
    (state) => state.payment.cardpayCardDetail
  );
  const paymentTag = useSelector((state) => state.payment.paymentTag);
  const promoCode = useSelector((state) => state.products.promoCode);
  const dispatch = useDispatch();

  // Lifecycle | Check for update | initCardpayPayment API Response
  useEffect(() => {
    if (initCardpayPaymentLoading) {
    } else if (initCardpayPaymentSuccess) {
      if (initCardpayPaymentData?.data?.url) {
        window.open(initCardpayPaymentData?.data?.url, "_self");
      }
    } else if (initCardpayPaymentError) {
      const obj = {
        message: initCardpayPaymentErrorData?.data?.message,
        autoClose: 3000,
      };
      dispatch(updateErrorToast(obj));
    }
  }, [
    initCardpayPaymentLoading,
    initCardpayPaymentSuccess,
    initCardpayPaymentError,
  ]);

  // Main Function
  const cardpayQuickPaymentFlow = () => {
    submitPayment();
  };

  // Part 1 |
  const submitPayment = () => {
    const payload = {
      payment_tag: paymentTag || "navbar-landing",
      product_hash_id: selectedCoinPackage?.product_hash_id,
      product_type: "coin",
      payment_token: cardpayCardDetail[0]?.token,
      promo_code: promoCode,
      redirect_url: `${window.origin}${routeConst.payment.cardpay.path}`,
    };
    initCardpayPayment(payload);

    dispatch(updatePaymentProcessDialog(true));
  };

  return cardpayQuickPaymentFlow;
};

export default useCardpayCoinsQuickPayment;
